import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default function Hosts(props) {
  const { hostlist, setState } = props;

  const handleChange = (event, value) => {
    let newSelected = [];
    const id = "hosts";
    value.map((val) => {
      newSelected.push(val.id);
    });
    setState((prevState) => ({
      ...prevState,
      [id]: newSelected,
    }));
  };

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      id="hosts"
      options={hostlist}
      getOptionLabel={(option) => option.hostname}
      filterSelectedOptions
      onChange={(event, value) => {
        handleChange(event, value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Select the profile to list the Hosts"
        />
      )}
    />
  );
}